import * as React from 'react';
import { FormControl } from '@common/components/form-control';

import './date.styles.scss';

export const Date = (props) => {
  const { value, className, metadata, onSave, moduleName } = props;

  const handleChange = React.useCallback((e) => {
    e.persist();

    const { value } = e.target;

    onSave({
      value,
      metadata,
    });
  }, [onSave, metadata]);

  return (
    <FormControl
      id={`${moduleName}-date--filter`}
      title={value}
      className={className}
      type="date"
      value={value}
      onChange={handleChange}
    />
  );
};

Date.defaultProps = {
  defaultValue: '',
};